"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinancialsHeader = void 0;
const React = require("react");
const moment = require("moment");
const core_1 = require("@material-ui/core");
const mobx_1 = require("mobx");
const app_settings_1 = require("shared/app-settings");
const select_1 = require("client/components/material/select");
const store_1 = require("client/modules/app-settings/store");
const ramda_1 = require("ramda");
const mobx_react_1 = require("mobx-react");
const store_2 = require("client/modules/users/store");
const store_3 = require("client/modules/sites/modules/sites-list/store");
const styles = core_1.createStyles({
    iconStyle: {
        marginRight: "1rem"
    },
    root: {
        alignItems: "center",
        background: "#d2d7e2",
        display: "flex",
        height: "5rem",
        justifyContent: "space-between",
        padding: "0 1rem"
    },
    title: {
        alignItems: "center",
        display: "flex"
    },
    titleContainer: {
        alignItems: "center",
        display: "flex"
    }
});
const decorate = core_1.withStyles(styles);
let FinancialsHeaderUnstyled = class FinancialsHeaderUnstyled extends React.Component {
    constructor() {
        super(...arguments);
        this.dateOptions = [
            {
                id: 0,
                label: "January 1 - January 15",
                value: ["", "01", "15"].join("-")
            },
            {
                id: 1,
                label: "January 16 - January 31",
                value: ["", "01", "31"].join("-")
            },
            {
                id: 2,
                label: "February 1 - February 15",
                value: ["", "02", "15"].join("-")
            },
            {
                id: 3,
                label: "February 16 - February 28",
                value: ["", "02", "28"].join("-")
            },
            {
                id: 4,
                label: "February 16 - February 29",
                value: ["", "02", "29"].join("-")
            },
            {
                id: 5,
                label: "March 1 - March 15",
                value: ["", "03", "15"].join("-")
            },
            {
                id: 6,
                label: "March 16 - March 31",
                value: ["", "03", "31"].join("-")
            },
            {
                id: 7,
                label: "April 1 - April 15",
                value: ["", "04", "15"].join("-")
            },
            {
                id: 8,
                label: "April 16 - April 30",
                value: ["", "04", "30"].join("-")
            },
            {
                id: 9,
                label: "May 1 - May 15",
                value: ["", "05", "15"].join("-")
            },
            {
                id: 10,
                label: "May 16 - May 31",
                value: ["", "05", "31"].join("-")
            },
            {
                id: 11,
                label: "June 1 - June 15",
                value: ["", "06", "15"].join("-")
            },
            {
                id: 12,
                label: "June 16 - June 30",
                value: ["", "06", "30"].join("-")
            },
            {
                id: 13,
                label: "July 1 - July 15",
                value: ["", "07", "15"].join("-")
            },
            {
                id: 14,
                label: "July 16 - July 31",
                value: ["", "07", "31"].join("-")
            },
            {
                id: 15,
                label: "August 1 - August 15",
                value: ["", "08", "15"].join("-")
            },
            {
                id: 16,
                label: "August 16 - August 31",
                value: ["", "08", "31"].join("-")
            },
            {
                id: 17,
                label: "September 1 - September 15",
                value: ["", "09", "15"].join("-")
            },
            {
                id: 18,
                label: "September 16 - September 30",
                value: ["", "09", "30"].join("-")
            },
            {
                id: 19,
                label: "October 1 - October 15",
                value: ["", "10", "15"].join("-")
            },
            {
                id: 20,
                label: "October 16 - October 31",
                value: ["", "10", "31"].join("-")
            },
            {
                id: 21,
                label: "November 1 - November 15",
                value: ["", "11", "15"].join("-")
            },
            {
                id: 22,
                label: "November 16 - November 30",
                value: ["", "11", "30"].join("-")
            },
            {
                id: 23,
                label: "December 1 - December 15",
                value: ["", "12", "15"].join("-")
            },
            {
                id: 24,
                label: "December 16 - December 31",
                value: ["", "12", "31"].join("-")
            }
        ];
        // @computed
        this.availableDateOptions = () => {
            const options = [];
            // const payPeriods = this.payPeriods;
            const currentDate = new Date();
            // const month = currentDate.getMonth();
            const year = currentDate.getFullYear();
            const prevyear = String(year - 1);
            const twoYearsAgo = String(year - 2);
            // const nextyear = year + 1; // just for testing if isLeap year test works
            const isLeap = (year) => new Date(year, 1, 29).getDate() === 29;
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            let removed;
            // create 3 separate dateOptions arrays that will be spliced individually based on leap year
            const dateOptionsCurrent = this.dateOptions.map(e => e);
            const dateOptionsPrevyear = this.dateOptions.map(e => e);
            const dateOptionsTwoYearsAgo = this.dateOptions.map(e => e);
            if (isLeap(year)) {
                removed = dateOptionsCurrent.splice(3, 1);
            }
            else {
                removed = dateOptionsCurrent.splice(4, 1);
            }
            if (isLeap(Number(prevyear))) {
                removed = dateOptionsPrevyear.splice(3, 1);
            }
            else {
                removed = dateOptionsPrevyear.splice(4, 1);
            }
            if (isLeap(Number(twoYearsAgo))) {
                removed = dateOptionsTwoYearsAgo.splice(3, 1);
            }
            else {
                removed = dateOptionsTwoYearsAgo.splice(4, 1);
            }
            // filter through dateOptions to get specified periods (from dev settings) in available options
            const startRanges = dateOptionsCurrent.map(e => e.label.split(" - ")[0]);
            const curDate = moment().date();
            const lastRange = curDate <= 15 ? 16 : 1;
            // to start with current range
            const currentRange = curDate <= 15 ? 1 : 16;
            // const subMonth = curDate <= 15 ? 2 : 1; // to always get period one month ago
            const subMonth = curDate <= 15 ? 1 : 0; // to always get the previous period
            const endMonth = moment()
                .subtract(subMonth, "month")
                .format("MMMM");
            const endMonthCurrent = moment().format("MMMM");
            const lastRangeSearch = `${endMonth} ${lastRange}`;
            const currentRangeSearch = `${endMonthCurrent} ${currentRange}`;
            const currentRangeToUse = currentRangeSearch.concat(" - ", `${endMonthCurrent} ${curDate} (${year})`);
            const currentValueToUse = moment().format("YYYY-MM-DD");
            // console.log("lastRangeSearch", lastRangeSearch);
            // console.log("currentRangeSearch", currentRangeSearch);
            const lastRangeIndex = startRanges
                .map((d, i) => {
                if (d.includes(lastRangeSearch)) {
                    return i;
                }
                return null;
            })
                .filter(e => {
                if (e === null) {
                    return false;
                }
                return true;
            })[0];
            // console.log("lastRangeIndex", lastRangeIndex);
            // console.log("currentRangeIndex", currentRangeIndex);
            let index = lastRangeIndex;
            let indexYear = String(year);
            for (let realX = 1; realX <= this.payPeriods; realX++) {
                const x = realX - 1;
                const currentOptionIndexToAdd = lastRangeIndex - x;
                if (currentOptionIndexToAdd < 0) {
                    if (24 + currentOptionIndexToAdd < 0) {
                        if (index === 0) {
                            options.push(ramda_1.clone(dateOptionsPrevyear[index]));
                            indexYear = prevyear;
                        }
                        else {
                            options.push(ramda_1.clone(dateOptionsTwoYearsAgo[index]));
                            indexYear = twoYearsAgo;
                        }
                        index = 48 + currentOptionIndexToAdd;
                        options[x].id = x;
                        options[x].value = options[x].value.replace(/^/, `${indexYear}`);
                        options[x].label = options[x].label.concat(" ", `(${indexYear})`);
                    }
                    else {
                        if (index === 0) {
                            options.push(ramda_1.clone(dateOptionsCurrent[index]));
                            indexYear = String(year);
                        }
                        else {
                            options.push(ramda_1.clone(dateOptionsPrevyear[index]));
                            indexYear = prevyear;
                        }
                        index = 24 + currentOptionIndexToAdd;
                        options[x].id = x;
                        options[x].value = options[x].value.replace(/^/, `${indexYear}`);
                        options[x].label = options[x].label.concat(" ", `(${indexYear})`);
                    }
                }
                else {
                    options.push(ramda_1.clone(dateOptionsCurrent[index]));
                    index = currentOptionIndexToAdd;
                    indexYear = String(year);
                    options[x].id = x;
                    options[x].value = options[x].value.replace(/^/, `${indexYear}`);
                    options[x].label = options[x].label.concat(" ", `(${indexYear})`);
                }
            }
            options.shift();
            options.unshift({
                id: 0,
                label: currentRangeToUse,
                value: currentValueToUse
            });
            this.selectedEndDate = options[0].value;
            // console.log("date options", this.dateOptions);
            // console.log("options", options);
            // do not return full options array with two year range - just the last two periods
            return options;
            // return options.slice(0, 2);
        };
        this.handleChangeDate = (value) => {
            const { onChangePayPeriod } = this.props;
            this.selectedEndDate = value;
            // create start date
            const enddateArray = this.selectedEndDate.split("-");
            const arraytouse = enddateArray.slice(0, -1);
            if (enddateArray[2] <= "15") {
                arraytouse.push("01");
            }
            else {
                arraytouse.push("16");
            }
            this.selectedStartDate = arraytouse.join("-");
            const query = {
                endDate: this.selectedEndDate,
                startDate: this.selectedStartDate
            };
            onChangePayPeriod(query);
            // console.log("query in change date", query);
        };
        this.handleChangeSite = (id) => {
            const { onChangeSite } = this.props;
            this.siteId = Number(id);
            onChangeSite(this.siteId);
        };
    }
    // public availableOptionsSites = (): IMenuItem[] => {
    //   const options: IMenuItem[] = [];
    //   const isImbUser = usersStore.user.value.user;
    //   if (isImbUser) {
    //     if (sitesListStore.sites.value) {
    //       sitesListStore.sites.value.forEach((site, i) => {
    //         options.push({
    //           id: i,
    //           label: site.displayName || site.name,
    //           value: site.id.toString()
    //         });
    //       });
    //     }
    //   } else {
    //     const { site } = usersStore.user.value;
    //     const siteOption = {
    //       id: site.id,
    //       label: site.displayName || site.name,
    //       value: site.id
    //     };
    //     options.push(siteOption);
    //   }
    //   return options;
    // }
    availableOptionsSites() {
        const user = store_2.usersStore.user.value;
        const showAllSites = store_2.usersStore.permissions.ReadPharmacies;
        // Optimize filtering with early return and simplified conditions
        const filteredSites = store_3.sitesListStore.sites.value.filter(site => { var _a, _b; return showAllSites || (user && (site.id === ((_a = user.site) === null || _a === void 0 ? void 0 : _a.id) || ((_b = user === null || user === void 0 ? void 0 : user.sites) === null || _b === void 0 ? void 0 : _b.includes(site.id)))); });
        // Use map with index to create options
        const options = filteredSites.map((site, index) => ({
            id: index + 1,
            label: site.displayName || site.name,
            value: String(site.id)
        }));
        // Conditionally add "All Pharmacies" option
        return showAllSites
            ? [{ id: 0, label: "All Pharmacies", value: "0" }, ...options]
            : options;
    }
    async componentDidMount() {
        const payPeriods = await store_1.appSettingsStore.readSettings(app_settings_1.AppOption.EobPayPeriods, true);
        this.payPeriods = Number(payPeriods.value);
        // console.log("this.payperiods", this.payPeriods);
        // max pay Periods to load: 48 (2 years)
        if (this.payPeriods > 48) {
            this.payPeriods = 48;
        }
        this.options = this.availableDateOptions();
        this.selectedStartDate = moment()
            .startOf("month")
            .format("YYYY-MM-DD");
        this.siteId = store_2.usersStore.user.value.siteId;
        if (store_2.usersStore.user.value && store_2.usersStore.user.value.user) {
            await store_3.sitesListStore.loadSitesNoRelation();
        }
    }
    render() {
        const { headline = "Headline", withSwitch, icon, classes: { iconStyle, root, title, titleContainer } } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: root },
                React.createElement("div", { className: titleContainer },
                    icon ? React.createElement("span", { className: iconStyle }, icon) : null,
                    React.createElement(core_1.Typography, { className: title, variant: "headline" },
                        withSwitch ? `Viewing Period:` : "",
                        " ",
                        headline)),
                withSwitch && (React.createElement("div", { className: "filter-header__action" },
                    React.createElement(select_1.MaterialSelect, { options: this.options, required: true, searchable: true, label: "Pay Period", onSelect: this.handleChangeDate, value: String(this.selectedEndDate) || "", width: "300px" })))),
            React.createElement("div", { className: root },
                React.createElement("div", { className: titleContainer },
                    React.createElement(core_1.Typography, { className: title, variant: "headline" })),
                withSwitch && (React.createElement("div", { className: "filter-header__action" },
                    React.createElement(select_1.MaterialSelect, { options: this.availableOptionsSites(), required: true, searchable: true, label: "Pharmacy", onSelect: this.handleChangeSite, value: String(this.siteId) || "", width: "300px" }))))));
    }
};
__decorate([
    mobx_1.observable
], FinancialsHeaderUnstyled.prototype, "payPeriods", void 0);
__decorate([
    mobx_1.observable
], FinancialsHeaderUnstyled.prototype, "selectedEndDate", void 0);
__decorate([
    mobx_1.observable
], FinancialsHeaderUnstyled.prototype, "options", void 0);
__decorate([
    mobx_1.observable
], FinancialsHeaderUnstyled.prototype, "selectedStartDate", void 0);
__decorate([
    mobx_1.observable
], FinancialsHeaderUnstyled.prototype, "siteId", void 0);
__decorate([
    mobx_1.observable
], FinancialsHeaderUnstyled.prototype, "dateOptions", void 0);
__decorate([
    mobx_1.action
], FinancialsHeaderUnstyled.prototype, "handleChangeDate", void 0);
FinancialsHeaderUnstyled = __decorate([
    mobx_react_1.observer
], FinancialsHeaderUnstyled);
exports.FinancialsHeader = decorate(FinancialsHeaderUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/financial/modules/financials-view/components/financials-header/financials-header.tsx
// module id = 3451
// module chunks = 0